import { PlatformLegacyInterface } from "clearline-api";

export class Platform implements PlatformLegacyInterface {
  public id: number;

  public accountId: string;

  public code: string;
  public authorizationUrl: string;
  public name: string;
}
